<svg version="1.1"
     [style.width.px]="size"
     [style.height.px]="size"
     [style.fill]="fill"
     xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink">
    <use [attr.xlink:href]="iconUrl"></use>
</svg>
